import { AfterViewInit, Injectable, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '../models/FormGroup';
import { AbstractControl } from '../models/AbstractControl';
import { FormControl } from '../models/FormControl';
import _ from 'lodash';
import { FormArray } from '../models/FormArray';
import { FormArrayState, FormGroupState } from '../interfaces/Form';


@Injectable()

export class FormService implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }


  convertToFormData = data => {
    const form = new FormData();

    _.forOwn(data, (value, key) => {
      if (_.isArray(value)) {
        _.each(value, file => form.append(`${key}[]`, file, file.name));
      } else form.append(key, value);

    });

    return form;
  };

  convertToMediaType = (value, media_type) => {

    if (media_type) {
      switch (media_type.toLowerCase()) {
        case 'json':
          return JSON.stringify(value);
        case 'form-data':
          return this.convertToFormData(value);
        default:
          return value;
      }
    }
    return value;
  };

}


